import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import FeaturedManga from './components/FeaturedManga';
import CategoryNav from './components/CategoryNav';
import LatestUpdates from './components/LatestUpdates';
import HotRanking from './components/HotRanking';

export default function Home() {
  return (
    <>
      <ScrollToTop />

      {/* Schema.org JSON-LD: WebPage */}
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: '洞洞杂货铺漫画-在线免费阅读下拉式漫画-073漫画网',
          description:
            '在线免费阅读下拉式洞洞杂货铺漫画尽在073漫画网，操作便捷、加载快速，追漫不受限制。',
          url: 'https://073mh.com',
          isPartOf: {
            '@type': 'WebSite',
            name: '073漫画网',
            url: 'https://073mh.com',
          },
        })}
      </script>

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          <HeroSection />
          <FeaturedManga />
          <CategoryNav />
          <LatestUpdates />
          <HotRanking />

          {/* CTA Section */}
          <section className="py-12 md:py-16 px-4 md:px-6">
            <div className="max-w-3xl mx-auto text-center bg-background-100 rounded-2xl p-8 md:p-12">
              <h2 className="font-heading text-xl md:text-2xl text-foreground-900 mb-3">
                随时随地，畅享阅读
              </h2>
              <p className="text-sm text-foreground-600 mb-6 max-w-lg mx-auto leading-relaxed">
                073漫画网支持<strong>手机和电脑</strong>双端阅读，下拉式浏览操作便捷。
                无需下载APP，打开浏览器即可畅读<strong>洞洞杂货铺</strong>等海量漫画。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                <a
                  href="/article/1/1"
                  className="px-8 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap"
                >
                  立即开始阅读
                </a>
              </div>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}